import { Linking } from "react-native";

/** Downloads a server-generated file (exports, deliverables) — anchor-click
 *  on web, `Linking.openURL` fallback everywhere else. `base` resolves a
 *  relative backend URL (e.g. an export's `file.url`) against the API origin;
 *  omit it for URLs that are already absolute. */
export const downloadFile = (
  url: string,
  filename: string,
  base?: string,
): void => {
  const resolvedUrl = base ? new URL(url, base).toString() : url;
  if (typeof document !== "undefined") {
    const link = document.createElement("a");
    link.href = resolvedUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return;
  }
  Linking.openURL(resolvedUrl);
};
